import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SnelleBouwRenovatie from "./sections/SnelleBouwRenovatie";
import ImpactInNumbers from "./sections/ImpactInNumbers";
import TechnologieenExpertise from "./sections/TechnologieenExpertise";
import Succesverhalen from "./sections/Succesverhalen";
import ReadyForTheNextStep from "./sections/ReadyForTheNextStep";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SnelleBouwRenovatie />
      <ImpactInNumbers />
      <TechnologieenExpertise />
      <Succesverhalen />
      <ReadyForTheNextStep />
      <Footer />
    </div>;
}